import { render, staticRenderFns } from "./FloorPlans.vue?vue&type=template&id=08856330&lang=pug"
import script from "./FloorPlans.vue?vue&type=script&lang=js"
export * from "./FloorPlans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports